import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { AuthGuard } from '../../../../src/app/auth/auth.guard';
import { DataAssessmentsComponentComponent } from './data-assessments-component/data-assessments-component.component';
import { DataContentComponentComponent } from './data-content-component/data-content-component.component';
import { DataApplicationsComponentComponent } from './data-applications-component/data-applications-component.component';
import { DataDevicesComponentComponent } from './data-devices-component/data-devices-component.component';
import { DataUsersComponentComponent } from './data-users-component/data-users-component.component';
import { DataOverviewComponentComponent } from './data-overview-component/data-overview-component.component';

const routes: Routes = [
  {path: 'dashboard',
    children: [
      {path: '', redirectTo: 'overview', pathMatch: 'full'},
      {path: 'overview', component: DataOverviewComponentComponent, canActivate: [AuthGuard]},
      {path: 'users', component: DataUsersComponentComponent, canActivate: [AuthGuard],},
      {path: 'devices', component: DataDevicesComponentComponent, canActivate: [AuthGuard],},
      {path: 'applications', component: DataApplicationsComponentComponent, canActivate: [AuthGuard],},
      {path: 'content', component: DataContentComponentComponent, canActivate: [AuthGuard],},
      {path: 'assessments', component: DataAssessmentsComponentComponent,canActivate: [AuthGuard],}
    ]
  }
];

@NgModule({
  imports: [RouterModule.forRoot(routes, {useHash: true})],
  exports: [RouterModule]
})
export class AppRoutingModule { }
